import React from "react";
import { Eye, Bone, Users, Award, Clock,   } from "lucide-react";
import ScrollToTopButton from "./ScrollToTopButton";
import aboutUsImage from "../assets/AboutUS.jpeg";


const AboutUs = () => {
  const LegKneeIcon = ({ className }) => (
    <svg 
      xmlns="http://www.w3.org/2000/svg" 
      viewBox="0 0 24 24" 
      fill="none" 
      stroke="currentColor" 
      strokeWidth="2" 
      strokeLinecap="round" 
      strokeLinejoin="round" 
      className={className}
    >
      <path d="M4 3 L 10 8 L 10 16 C 10 20, 7 21, 4 21" />
      <circle cx="10" cy="8" r="2" />
    </svg>
  );
  return (
    <div className="bg-white font-sans mt-[36px]">
      {/* Hero Section - Modern Asymmetrical Design */}
      <section className="relative overflow-hidden bg-[#c8dff7] text-black">
  <div className="absolute -top-24 -right-24 w-64 h-64 rounded-full bg-violet-500 opacity-20"></div>
  <div className="absolute top-40 right-10 w-32 h-32 rounded-full bg-purple-400 opacity-20"></div>
  <div className="absolute bottom-10 left-10 w-48 h-48 rounded-full bg-indigo-500 opacity-10"></div>
  
  <div className="container mx-auto px-6 py-20 md:py-32">
    <div className="flex flex-col md:flex-row items-center">
      <div className="w-full md:w-1/2 md:pr-12 mb-12 md:mb-0">
        <h1 className="text-4xl md:text-6xl font-bold mb-6 leading-tight">
          Exceptional Care for Your <span className="text-black-300">Vision</span> & <span className="text-black-300">Mobility</span>
        </h1>
        <p className="text-lg text-black mb-8 max-w-lg">
          VisionMove Clinic combines cutting-edge technology with compassionate care to help you live your best life.
        </p>
        <div className="flex flex-wrap gap-4">
          <a href="/specialities" className="px-8 py-3 bg-transparent border-2 border-blue-700 hover:bg-white hover:text-purple-800 rounded-full font-medium transition-all">
            Our Services
          </a>
        </div>
      </div>
      <div className="w-full md:w-1/2">
        <div className="relative">
          <div className="absolute -left-4 -top-4 w-full h-full border-2 border-purple-400 rounded-xl"></div>
          <div className="w-full h-80 md:h-96 bg-gray-200 rounded-xl overflow-hidden shadow-2xl">
            <img
              src={aboutUsImage}
              alt="VisionMove Clinic Team"
              className="w-full h-full object-cover"
            />
          </div>
          <div className="absolute -right-6 -bottom-6 bg-gradient-to-br from-purple-600 to-violet-700 rounded-xl p-4 shadow-xl">
            <p className="text-3xl font-bold">25+</p>
            <p className="text-sm">Years of Excellence</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>

      {/* About Section - Modern Cards */}
      <section className="py-20" id="about">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-blue-600 font-semibold mb-2">WHO WE ARE</p>
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Our Story & Mission</h2>
            <div className="w-24 h-1 bg-blue-600 mx-auto"></div>
          </div>

          <div className="flex flex-col lg:flex-row gap-12 items-center">
            <div className="w-full lg:w-1/2">
              <div className="relative aspect-square max-w-lg mx-auto">
                <div className="absolute inset-0 bg-blue-100 rounded-full"></div>
                <div className="absolute inset-4 bg-white rounded-full shadow-xl"></div>
                <div className="absolute inset-10 overflow-hidden rounded-full">
                  <img 
                    src="images/monikadr.jpeg" 
                    alt="Clinic Interior" 
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
            </div>
            
            <div className="w-full lg:w-1/2">
              <h3 className="text-2xl font-bold text-gray-800 mb-4"> </h3>
              <b>  <p className="text-gray-600 mb-6 text-lg">
              Dr Monika Naiknimbalkar             <br></br>
              MBBS DOMS DNB( Ophthalm)
              </p> </b>
              <p className="text-gray-600 mb-6 text-lg">
              Started Unity Ortho and Eye Hospital  along with her husband Dr Jagjeet in the year 2021 . 
The hospital is situated at a very auspicious site of Shri Shankar Maharaj math . 
The inauguration was done by none other that Padmashree Dr K Sancheti .               </p>
              <p className="text-gray-600 mb-8 text-lg">
              Dr Monika has been proficient in cataract surgeries since last 25 years . She is trained to do complex cataract surgeries, lasik surgery ( to remove the refractive error / glasses) . More than thousands of such surgeries have been performed in their own exclusive  modern operation theatre. 
 State of the art equipment with the best care is available. 

Other surgeries like occuplastic procedures , retinal surgery etc are done in collaboration with her colleagues. 
Hence ,  pan ophthalmic care is provided for the patients all under one roof .
Unity hospital is also empanelled with all the mediclaim companies .

She has also been an officer bearer in the capacity of Treasurer  and Editor of Poona Ophthalmology Society. She has contributed immensely towards the progress of the society and has been aptly rewarded by the Jhamwar award for the same .              </p>
              
             
            </div>
          </div>
        </div>
      </section>

      <section className="py-20" id="about">
        <div className="container mx-auto px-6">
    

    {/* Image on right for large screens */}
    <div className="flex flex-col lg:flex-row-reverse gap-12 items-center">
      <div className="w-full lg:w-1/2">
        <div className="relative aspect-square max-w-lg mx-auto">
          <div className="absolute inset-0 bg-blue-100 rounded-full"></div>
          <div className="absolute inset-4 bg-white rounded-full shadow-xl"></div>
          <div className="absolute inset-10 overflow-hidden rounded-full">
            <img 
              src="images/jagtjeetdr.jpeg" 
              alt="Clinic Interior" 
              className="w-full h-full object-cover"
            />
          </div>
        </div>
      </div>

      <div className="w-full lg:w-1/2">
        <h3 className="text-2xl font-bold text-gray-800 mb-4">Excellence in Orthopaedic Surgeon Since 2001</h3>
      <b>  <p className="text-gray-600 mb-6 text-lg">
        Dr. Jagjeet M. Naik-Nimbalkar       
      <br></br>
        Orthopaedic Surgeon | Dhankawadi, Pune
        </p> </b>
        <p> Dr. Jagjeet M. Naik-Nimbalkar is a highly experienced and trusted orthopaedic surgeon practicing in Pune since 2001, with over 25 years of professional experience. He specializes in:

Complex fractures & trauma care

Joint replacements (Knee, Hip, Shoulder)

Arthroscopy & spine surgeries

Pediatric orthopaedics, foot & ankle, and cancer-related bone surgeries</p>
<p> He is the founder of Unity Ortho & Eye Hospital, a state-of-the-art 10-bed facility in Dhankawadi, and is currently building Unity Multicare Hospital, a 120-bed super-specialty hospital designed to meet international standards.

With a dedicated team of specialists, Dr. Naik-Nimbalkar has successfully performed numerous complex procedures, including re-implantation, plastic reconstructive surgeries, and endoscopic spine surgeries.

At Unity Hospital, the focus is on delivering quality care, excellent service, and patient satisfaction through a committed and skilled medical team.</p>

       
      </div>
    </div>
  </div>
</section>





      {/* Services Section - Tabbed Cards */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-blue-600 font-semibold mb-2">OUR SERVICES</p>
            <h2 className="text-4xl font-bold text-gray-800 mb-4">Specialized Care</h2>
            <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
            <p className="text-gray-600 max-w-2xl mx-auto">
              We offer comprehensive solutions for all your vision and mobility needs with cutting-edge technology and personalized treatment plans.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-10 max-w-5xl mx-auto">
            {/* Ophthalmology Card */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all hover:-translate-y-2 hover:shadow-2xl">
              <div className="h-3 bg-blue-600"></div>
              <div className="p-8">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-blue-100 rounded-2xl flex items-center justify-center mr-4">
                    <Eye className="w-8 h-8 text-blue-600" />
                  </div>
                  <h3 className="text-2xl font-bold text-gray-800">Vision Care</h3>
                </div>
                
                <p className="text-gray-600 mb-6">
                  Our ophthalmology department offers comprehensive eye examinations, advanced diagnostic testing, and cutting-edge treatments for all eye conditions.
                </p>
                
                <div className="space-y-4 mb-8">
                <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Phacoemulsification (Phaco Surgery)</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Cataract Surgery</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Diabetic Retinopathy</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Cornea and Associated Diseases</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Glaucoma Treatment</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Neuro-Ophthalmology</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Oculoplasty</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Pediatric Ophthalmology</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Refractive Surgeries</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Retina and Associated Diseases</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700"> LASIK Surgery</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">ICL Eye Surgery</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Photorefractive Keratectomy</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-blue-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Squint Eye</span>
                  </div>
                 
                </div>
                
                <a href="/specialities" className="inline-flex items-center text-blue-600 font-semibold hover:text-blue-800">
                  Learn more
                  <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                  </svg>
                </a>
              </div>
            </div>

            {/* Orthopedics Card */}
            <div className="bg-white rounded-2xl shadow-xl overflow-hidden transform transition-all hover:-translate-y-2 hover:shadow-2xl">
              <div className="h-3 bg-green-600"></div>
              <div className="p-8">
                <div className="flex items-center mb-6">
                  <div className="w-16 h-16 bg-green-100 rounded-2xl flex items-center justify-center mr-4">
                  <LegKneeIcon className="w-8 h-8 text-green-600" />                  </div>
                  <h3 className="text-2xl font-bold text-gray-800">Orthopedic Care</h3>
                </div>
                
                <p className="text-gray-600 mb-6">
                  Our orthopedic department provides comprehensive diagnosis, treatment, and rehabilitation for all musculoskeletal conditions.
                </p>
                
                <div className="space-y-4 mb-8">
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Trauma Surgery</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Knee Replacement Surgery</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Hip Replacement Surgery</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Shoulder Surgery</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Spine Surgery</span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Foot & Ankle Surgery </span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Pediatric Orthopedic Surgery </span>
                  </div>
                  <div className="flex items-center">
                    <div className="w-2 h-2 bg-green-600 rounded-full mr-3"></div>
                    <span className="text-gray-700">Arthroscopies Surgery </span>
                  </div>
                </div>
                
                <a href="/specialities" className="inline-flex items-center text-green-600 font-semibold hover:text-green-800">
                  Learn more
                  <svg className="w-4 h-4 ml-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path strokeLinecap="round" strokeLinejoin="round" strokeWidth="2" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
                  </svg>
                </a>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Why Choose Us - Feature Cards */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-6">
          <div className="text-center mb-16">
            <p className="text-blue-600 font-semibold mb-2">WHY CHOOSE US</p>
            <h2 className="text-4xl font-bold text-gray-800 mb-4">The VisionMove Advantage</h2>
            <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
            <p className="text-gray-600 max-w-2xl mx-auto">
              What makes our approach to healthcare different and why patients trust us for their vision and mobility needs.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {/* Card 1 */}
            <div className="bg-gradient-to-br from-blue-50 to-blue-100 rounded-xl p-8 shadow-md hover:shadow-xl transition-shadow">
              <div className="inline-block p-4 bg-blue-200 rounded-xl mb-6">
                <Award className="w-8 h-8 text-blue-700" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Expert Specialists</h3>
              <p className="text-gray-600">
                Our team of board-certified specialists have trained at top institutions and bring decades of combined experience to your care.
              </p>
            </div>

            {/* Card 2 */}
            <div className="bg-gradient-to-br from-green-50 to-green-100 rounded-xl p-8 shadow-md hover:shadow-xl transition-shadow">
              <div className="inline-block p-4 bg-green-200 rounded-xl mb-6">
                <Clock className="w-8 h-8 text-green-700" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Efficient Care</h3>
              <p className="text-gray-600">
                We value your time with streamlined appointment scheduling, minimal wait times, and coordinated care between specialties.
              </p>
            </div>

            {/* Card 3 */}
            <div className="bg-gradient-to-br from-purple-50 to-purple-100 rounded-xl p-8 shadow-md hover:shadow-xl transition-shadow">
              <div className="inline-block p-4 bg-purple-200 rounded-xl mb-6">
                <Users className="w-8 h-8 text-purple-700" />
              </div>
              <h3 className="text-xl font-bold text-gray-800 mb-4">Personalized Approach</h3>
              <p className="text-gray-600">
                We create individualized treatment plans that address your specific needs, lifestyle, and long-term health goals.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Team Section - Modern Cards */}
      <section className="py-20 bg-gray-50" id="team">
  <div className="container mx-auto px-6">
    <div className="text-center mb-16">
      <h2 className="text-5xl font-bold text-gray-800 mb-4">Meet Our Team</h2>
      <div className="w-24 h-1 bg-blue-600 mx-auto mb-6"></div>
      <p className="text-gray-600 max-w-2xl mx-auto">
        Our team of specialists are leaders in their fields, committed to providing exceptional care with compassion.
      </p>
    </div>
    
    {/* Centered grid container */}
    <div className="flex justify-center py-8">
      <div className="grid gap-10 grid-cols-1 md:grid-cols-2 max-w-4xl mx-auto">
        {/* Doctor Card 1 */}
        <div className="group relative w-full overflow-hidden rounded-2xl shadow-xl bg-white transition-all duration-300 hover:shadow-2xl">
          <div className="relative h-72 overflow-hidden">
            <img
              src="images/dr2.jpeg"
              alt="Dr. Monika J. Naik-Nimbalkar"
              className="w-full h-full object-cover object-center transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900 to-transparent opacity-0 group-hover:opacity-90 transition-opacity duration-500 flex items-end">
              <div className="p-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <p className="font-medium">
                  Specializing in cataract surgery and LASIK with over 15 years of experience.
                </p>
              </div>
            </div>
          </div>
          <div className="p-4 text-center">
            <h3 className="text-xl font-bold text-gray-800">Dr. Monika J. Naik-Nimbalkar</h3>
            <p className="text-blue-600">Eye Specialist</p>
            <p className="text-blue-600 font-bold">M.B.B.S., D.O.M.S., D.N.B (ophthalmologist)</p>
          </div>
        </div>

        {/* Doctor Card 2 */}
        <div className="group relative w-full overflow-hidden rounded-2xl shadow-xl bg-white transition-all duration-300 hover:shadow-2xl">
          <div className="relative h-72 overflow-hidden">
            <img
              src="images/dr1.jpeg"
              alt="Dr. Jagjeet"
              className="w-full h-full object-cover object-top transition-transform duration-500 group-hover:scale-110"
            />
            <div className="absolute inset-0 bg-gradient-to-t from-blue-900 to-transparent opacity-0 group-hover:opacity-90 transition-opacity duration-500 flex items-end">
              <div className="p-4 text-white opacity-0 group-hover:opacity-100 transition-opacity duration-500">
                <p className="font-medium">
                  Expert in joint replacement and sports medicine with specialized training.
                </p>
              </div>
            </div>
          </div>
          <div className="p-4 text-center">
            <h3 className="text-xl font-bold text-gray-800">Dr. Jagjeet M. Naik-Nimbalkar</h3>
            <p className="text-blue-600">Orthopedic Surgeon</p>
            <p className="text-blue-600 font-bold">M.B.B.S, Dorth, D.N.B (orthopedic)</p>
          </div>
        </div>
      </div>
    </div>
  </div>
</section>
<ScrollToTopButton />
     
    </div>
  );
};

export default AboutUs;